import { contractActions } from "./ContractReducer";
import { useContractAPI  } from '../../api/contract/useContractAPI';

export const useContract = () => {
  const api = useContractAPI();
  const request = {
    get: (params) => {
      return async (dispatch) => {
        try {
          const response = await api.contract.get(params);
          dispatch(contractActions.funGetContracts(response));
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    },
    post: async (data) => {
      return await api.contract.post(data);
    },
    put: async (data) => {
      return await api.contract.put(data);
    },
    complete: async (data) => {
      return await api.contract.complete(data);
    },
    delete: async (params) => {
      return await api.contract.delete(params);
    },
    import: async (formData) => {
      return await api.contract.import(formData);
    },
    test: async (params) => {
      return await api.contract.test(params);
    }
  };
  return { request };
  };